import * as React from 'react';
import { useGetList, LinearProgress } from 'react-admin';
import SMeter from './SMeter';

const BusinessViewCount = ({ style = {}, id }) => {
	const queryDate = new Date();
	queryDate.setHours(0, 0, 0, 0);
	queryDate.setDate(queryDate.getDate() - 14);
	const { data: eventData, isError, isLoading } = useGetList(
		'AppEvent',
		{
			pagination: { page: 1, perPage: 100 },
			sort: { field: 'dateTime', order: 'DESC' },
			filter: { name: 'businessOpened', 'params.id': id, dateTime: { $gt: queryDate } },
		},
	);

	if (!isLoading && isError) { return 'error'; }

	if (isLoading) { return <LinearProgress />; }

	if (!eventData) { return 'no event data'; }

	const data = eventData.reduce(
		(a, v) => {
			const date = new Date(
				v.dateTime.getFullYear(),
				v.dateTime.getMonth(),
				v.dateTime.getDate(),
			).getTime();
			return a.set(date, a.has(date) ? a.get(date) + 1 : 1);
		},
		new Map(),
	);
	const array = Array.from(data.entries())
		.sort(([k1], [k2]) => (k1 - k2));
	const values = array.map((v) => v[1]);
	const labels = array.map((v) => new Date(v[0])).map((v) => `${v.getDate()}.${v.getMonth() + 1}`);

	return (
		<SMeter
			data={values}
			labels={labels}
			style={style}
			title="Количество просмотров"
		/>
	);
};

export default BusinessViewCount;
